import { getSuggestions } from '../utils/getSuggestions';

export const shouldOmitPopover = (): boolean => {
    return !getSuggestions();
};
